export const removeSurroundingQuotes = (maybeQuotedString: string): string =>
	maybeQuotedString.replace(/^["']|["']$/g, '');
